var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3,17.7H1.7c-.6,0-1-.4-1-1s.4-1,1-1h.7V6c0-1.1,0-1.6.3-2.2.3-.5.7-.9,1.2-1.2.6-.3,1.2-.3,2.2-.3h1.3c1.1,0,1.6,0,2.2.3.5.3.9.7,1.2,1.2.3.6.3,1.2.3,2.2v.5c.1,0,.2,0,.3-.1.5-.2,1-.2,1.5,0,.6.2,1,.5,1.7,1.2l1.9,1.7c.4.3.6.5.8.8.2.2.3.5.4.8,0,.3,0,.6,0,1.1v3.7h.7c.6,0,1,.4,1,1s-.4,1-1,1ZM8.5,15.7h7.2v-3.7c0-.3,0-.5,0-.6,0,0,0-.1,0-.2,0,0-.2-.2-.4-.4l-1.9-1.7c-.4-.4-.8-.7-.9-.7-.1,0-.3,0-.4,0-.1,0-.5.4-.9.7l-1.9,1.7c-.2.2-.4.4-.4.4,0,0,0,.1,0,.2,0,0,0,.3,0,.6v3.7ZM4.3,15.7h2.2v-3.7c0-.5,0-.8,0-1.1,0-.3.2-.6.4-.8.2-.3.4-.5.8-.8l1.3-1.2v-2.1c0-.6,0-1.2,0-1.3,0-.1-.2-.2-.3-.3-.1,0-.7,0-1.3,0h-1.3c-.6,0-1.2,0-1.3,0-.1,0-.2.2-.3.3,0,.1,0,.7,0,1.3v9.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding01);
export default __webpack_public_path__ + "static/media/Building_01.ba0072ae2a428493ead579fdaa13f9ae.svg";
export { ForwardRef as ReactComponent };